import React from 'react';
import { cn } from '../../utils';

export const CardLayout = ({
  children,
  className,
}: {
  children: React.ReactNode;
  /**
   * Extra classes on the grid container. Defaults to nothing extra, so
   * every existing caller keeps today's exact layout (grid rows share
   * leftover h-screen space via the default `align-content`, which can
   * leave a large gap after a short row - e.g. a mobile logo banner - when
   * the other row's content is also short).
   */
  className?: string;
}) => (
  <div
    className={cn(
      'container relative h-screen flex-col items-center justify-center grid lg:max-w-none lg:grid-cols-2 lg:px-0',
      className
    )}
  >
    {children}
  </div>
);
